function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "75.31%",
  y1: "0%",
  x2: "75.31%",
  y2: "100%",
  id: "download-guide_svg__a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E4E8F2",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C9CDD9",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "75.31%",
  y1: "3.622%",
  x2: "75.31%",
  y2: "100%",
  id: "download-guide_svg__b"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E4E8F2",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C9CDD9",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "75.31%",
  y1: "0%",
  x2: "75.31%",
  y2: "100%",
  id: "download-guide_svg__c"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E4E8F2",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C9CDD9",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "18.772%",
  y1: "44.846%",
  x2: "55.732%",
  y2: "54.568%",
  id: "download-guide_svg__d"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E3FFFC",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#48D59F",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "download-guide_svg__e"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E3FFFC",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#48D59F",
  offset: "100%"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#download-guide_svg__a)",
  d: "M0 0v32h2V2h26V0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#download-guide_svg__b)",
  d: "M32 4H4v32h2V6h26z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 40h28V8H8v32zm2-2h24V10H10v28z",
  fill: "url(#download-guide_svg__c)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#download-guide_svg__d)",
  d: "M14 34h16v-2H14z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#download-guide_svg__e)",
  d: "M22 30l8-8h-4v-8h-8v8h-4z"
}));

function SvgDownloadGuide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzYgNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IHgxPSI3NS4zMSUiIHkxPSIwJSIgeDI9Ijc1LjMxJSIgeTI9IjEwMCUiIGlkPSJhIj48c3RvcCBzdG9wLWNvbG9yPSIjRTRFOEYyIiBvZmZzZXQ9IjAlIi8+PHN0b3Agc3RvcC1jb2xvcj0iI0M5Q0REOSIgb2Zmc2V0PSIxMDAlIi8+PC9saW5lYXJHcmFkaWVudD48bGluZWFyR3JhZGllbnQgeDE9Ijc1LjMxJSIgeTE9IjMuNjIyJSIgeDI9Ijc1LjMxJSIgeTI9IjEwMCUiIGlkPSJiIj48c3RvcCBzdG9wLWNvbG9yPSIjRTRFOEYyIiBvZmZzZXQ9IjAlIi8+PHN0b3Agc3RvcC1jb2xvcj0iI0M5Q0REOSIgb2Zmc2V0PSIxMDAlIi8+PC9saW5lYXJHcmFkaWVudD48bGluZWFyR3JhZGllbnQgeDE9Ijc1LjMxJSIgeTE9IjAlIiB4Mj0iNzUuMzElIiB5Mj0iMTAwJSIgaWQ9ImMiPjxzdG9wIHN0b3AtY29sb3I9IiNFNEU4RjIiIG9mZnNldD0iMCUiLz48c3RvcCBzdG9wLWNvbG9yPSIjQzlDREQ5IiBvZmZzZXQ9IjEwMCUiLz48L2xpbmVhckdyYWRpZW50PjxsaW5lYXJHcmFkaWVudCB4MT0iMTguNzcyJSIgeTE9IjQ0Ljg0NiUiIHgyPSI1NS43MzIlIiB5Mj0iNTQuNTY4JSIgaWQ9ImQiPjxzdG9wIHN0b3AtY29sb3I9IiNFM0ZGRkMiIG9mZnNldD0iMCUiLz48c3RvcCBzdG9wLWNvbG9yPSIjNDhENTlGIiBvZmZzZXQ9IjEwMCUiLz48L2xpbmVhckdyYWRpZW50PjxsaW5lYXJHcmFkaWVudCB4MT0iNTAlIiB5MT0iMCUiIHgyPSI1MCUiIHkyPSIxMDAlIiBpZD0iZSI+PHN0b3Agc3RvcC1jb2xvcj0iI0UzRkZGQyIgb2Zmc2V0PSIwJSIvPjxzdG9wIHN0b3AtY29sb3I9IiM0OEQ1OUYiIG9mZnNldD0iMTAwJSIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PHBhdGggZmlsbD0idXJsKCNhKSIgZD0iTTAgMHYzMmgyVjJoMjZWMHoiLz48cGF0aCBmaWxsPSJ1cmwoI2IpIiBkPSJNMzIgNEg0djMyaDJWNmgyNnoiLz48cGF0aCBkPSJNOCA0MGgyOFY4SDh2MzJ6bTItMmgyNFYxMEgxMHYyOHoiIGZpbGw9InVybCgjYykiLz48cGF0aCBmaWxsPSJ1cmwoI2QpIiBkPSJNMTQgMzRoMTZ2LTJIMTR6Ii8+PHBhdGggZmlsbD0idXJsKCNlKSIgZD0iTTIyIDMwbDgtOGgtNHYtOGgtOHY4aC00eiIvPjwvZz48L3N2Zz4K";
export { SvgDownloadGuide as ReactComponent };